import Vue from 'vue';
import VueRouter from 'vue-router';
import { routes } from './routes';
import i18n from '../i18n';
 
Vue.use(VueRouter);
 
const supportedLanguages = ['en', 'sv', 'fi'];
const publicRoutesWithoutLang = ['/login', '/recover-password', '/reset-password'];
 
const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  linkActiveClass: 'is-active',
  routes
});
 
router.beforeEach((to, from, next) => {
  const storedLang = localStorage.getItem('lang');
  const fallbackLang = supportedLanguages.includes(storedLang) ? storedLang : 'sv';
  const urlLang = supportedLanguages.includes(to.params.lang) ? to.params.lang : null;
 
  const simplePath = to.path.replace(/^\/(en|sv|fi)(?=\/|$)/, '');
  const activeLang = urlLang || fallbackLang;
 
  if (publicRoutesWithoutLang.some(route => simplePath.startsWith(route))) {
 
    if (!urlLang) {
      return next(`/${activeLang}${simplePath}`);
    }
 
    if (i18n.locale !== activeLang) {
      i18n.locale = activeLang;
      localStorage.setItem('lang', activeLang);
    }
    return next();
  }
 
  const pathWithoutLang = to.fullPath.replace(/^\/(en|sv|fi)(?=\/|$)/, '');
  if (!urlLang) {
    return next(`/${activeLang}${pathWithoutLang}`);
  }
  if (i18n.locale !== activeLang) {
    i18n.locale = activeLang;
    localStorage.setItem('lang', activeLang);
  }
 
  let auth = null;
  try {
    auth = JSON.parse(localStorage.getItem('brandexp') || 'null');
  } catch (e) {
    auth = null;
  }
 
  const token =
    auth?.user?.token?.token ??
    auth?.token?.token ??
    auth?.token ??
    null;
 
  if (!token) {
    console.log('No token found');
    return next(`/${activeLang}/login`);
  }
 
 
  if (publicRoutesWithoutLang.some(route => simplePath.startsWith(route)))  {
    return next(`/${activeLang}/`);
  }
 
  return next();
});
 
export default router;
 
 